import { createContext, useContext, useState } from "react";

const FormContext = createContext();

const FormContextProvider = ({ children }) => {
  const [activetab, setActiveTab] = useState(null);
  const [FORMDATA, setFormData] = useState(null);

  const setData = (data) => {
    // console.log("SETTING DATA FORM CONTEXT", data)
    setFormData(data);
  };
  const clearAll = () => {
    // console.log("CLEARING FORM CONTEXT");
    setActiveTab(null);
    setFormData(null);
  };
  const setTab = (tab) => {
    // console.log("SETTING TAB FORM CONTEXT", tab)

    setActiveTab(tab);
  };
  console.log({ activetab, FORMDATA }, "FORM DATA CONTEXT");
  return (
    <FormContext.Provider
      value={{ activetab, FORMDATA, setData, clearAll, setTab }}
    >
      {children}
    </FormContext.Provider>
  );
};

export const useFormContext = () => useContext(FormContext);

export default FormContextProvider;
